import { Button } from '@mui/material';
import type { ReportingInsightsStarterPrompt } from './AIInsightsButton.helpers';

export const AIInsightsStarterPrompt = ({
  prompt,
  onRunPrompt,
  disabled,
}: {
  prompt: ReportingInsightsStarterPrompt;
  onRunPrompt: (
    promptId: ReportingInsightsStarterPrompt['id'],
    label: string,
  ) => void;
  disabled: boolean;
}) => {
  return (
    <Button
      variant="contained"
      onClick={() => onRunPrompt(prompt.id, prompt.label)}
      disabled={disabled}
      sx={(theme) => ({
        alignSelf: 'flex-start',
        backgroundColor: theme.lighten(theme.palette.other.spaceCadet, 0.1),
        border: '1px solid',
        borderColor: theme.alpha(theme.palette.common.white, 0.35),
        borderRadius: '4px',
        typography: 'body3',
        pl: 1,
        pr: 2,
        mr: 4,
        py: 1,
        color: 'common.white',
        '&:hover': {
          backgroundColor: theme.lighten(theme.palette.other.spaceCadet, 0.15),
          borderColor: theme.alpha(theme.palette.common.white, 0.45),
        },
      })}
    >
      {prompt.label}
    </Button>
  );
};
